<button mat-icon-button class="super-ejecutivo-descarga-boton" [matMenuTriggerFor]="menuDescarga" [disabled]="descargando()"
  [matTooltip]="etiqueta()" [attr.aria-label]="etiqueta()">
  <mat-icon>download</mat-icon>
</button>
<mat-menu #menuDescarga="matMenu" xPosition="before">
  <button mat-menu-item (click)="imagen.emit()">
    <mat-icon>image</mat-icon>
    <span>{{ textos.IMAGEN }}</span>
  </button>
  <button mat-menu-item (click)="excel.emit()">
    <mat-icon>table_chart</mat-icon>
    <span>{{ textos.EXCEL }}</span>
  </button>
</mat-menu>
